import { ComboboxData, Group, Stack } from "@mantine/core"
import { Loader, Select } from "@tfg/ui"
import { useEffect, useState } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { useFindMaterialTypes } from "~/gen/api"
import { filterDeletedAtSelectOptions } from "~/pages/Admin/Mapping/components/MappingSelect"
import { EditableCellWithTextInput } from "~/pages/Admin/Translations/columns.tsx"
import { useUpdateMaterialMutation } from "~/pages/Brand/Products/Details/hooks.ts"

type Props = {
  material: LibraryResponses.EnrichedMaterial
}

export function MaterialPropertySelection({ material }: Props) {
  const { data: materialTypeList, isPending: isLoading } = useFindMaterialTypes(
    {
      filters: {
        operationChainName: material.type.materialOpChain,
      },
    }
  )
  const [selectOptions, setSelectOptions] = useState<ComboboxData>([])
  const { mutate: updateMaterial } = useUpdateMaterialMutation()

  useEffect(() => {
    setSelectOptions(
      filterDeletedAtSelectOptions(
        materialTypeList?.data.materialTypes,
        material.type.id
      )
    )
  }, [material, materialTypeList])

  if (isLoading) {
    return <Loader fullPage />
  } else {
    return (
      <Stack gap="xs" align="flex-start">
        <Group justify="space-between" w="100%" wrap="nowrap">
          <Select
            value={material.type.id.toString()}
            data={selectOptions}
            onChange={(newValue) =>
              updateMaterial({
                id: material.id,
                typeId: materialTypeList?.data.materialTypes?.find(
                  (materialType) => materialType.id === Number(newValue)
                )?.id,
              })
            }
            searchable
          />
          <EditableCellWithTextInput
            key={material.id}
            defaultValue={material.proportion.toString()}
            onSave={(newValue: string) =>
              updateMaterial({
                id: material.id,
                proportion: parseFloat(newValue),
              })
            }
          />
        </Group>
      </Stack>
    )
  }
}
